import React from 'react'
import "./newteam.css";
import {FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram, FaGithub} from 'react-icons/fa'

import shubham from '../../assets/POR/Shubham - Director Content.jpg'
import ayush from "../../assets/GD/Ayush Jha - Execomm.jpg";
import Shhouraya from "../../assets/GD/Shhouraya - Execomm_.jpg"
import Siddharth from "../../assets/GD/Siddharth goenka-Execomm.jpg"
import Kritika from "../../assets/GD/Kritika Choudhary -Execom.jpg"

const Newteam = () => {
  return (
    <>
    <h2 className="main-title">GD Team</h2>
    <div class="nnn">
    <div className="cont">
        <div className="cards">
          <div className="imgbox">
            <img src={shubham} alt="" />
          </div>
          <div className="content">
            <div className="details">
              <h2>Shubham Bamnawat <br /><span>web developer</span></h2>
              <ul className="social_media">
              <li><a href="#"><FaInstagram className="i" /></a></li>
                <li><a href="#"><FaLinkedinIn className="i" /></a></li>
                <li><a href="#"><FaFacebookF className="i" /></a></li>
                {/* <li><a href="#"><FaGithub className="i" /></a></li> */}
              </ul>
            </div>
          </div>
        </div>

        <div className="cards">
          <div className="imgbox">
            <img src={ayush} alt="" />
          </div>
          <div className="content">
            <div className="details">
              <h2>Ayush Jha <br /><span>web developer</span></h2>
              <ul className="social_media">
              <li><a href="#"><FaInstagram className="i" /></a></li>
                <li><a href="#"><FaLinkedinIn className="i" /></a></li>
                <li><a href="#"><FaFacebookF className="i" /></a></li>
                {/* <li><a href="#"><FaGithub className="i" /></a></li> */}
              </ul>
            </div>
          </div>
        </div>

        <div className="cards">
          <div className="imgbox">
            <img src={Siddharth} alt="" />
          </div>
          <div className="content">
            <div className="details">
              <h2>Siddharth Goenka <br /><span>web developer</span></h2>
              <ul className="social_media">
              <li><a href="#"><FaInstagram className="i" /></a></li>
                <li><a href="#"><FaLinkedinIn className="i" /></a></li>
                <li><a href="#"><FaFacebookF className="i" /></a></li>
                {/* <li><a href="#"><FaGithub className="i" /></a></li> */}
              </ul>
            </div>
          </div>
        </div>

        <div className="cards">
          <div className="imgbox">
            <img src={ Kritika} alt="" />
          </div>
          <div className="content">
            <div className="details">
              <h2>Kritika Choudhary <br /><span>web developer</span></h2>
              <ul className="social_media">
              <li><a href="#"><FaInstagram className="i" /></a></li>
                <li><a href="#"><FaLinkedinIn className="i" /></a></li>
                <li><a href="#"><FaFacebookF className="i" /></a></li>
                {/* <li><a href="#"><FaGithub className="i" /></a></li> */}
              </ul>
            </div>
          </div>
        </div>


        <div className="cards">
          <div className="imgbox">
            <img src={Shhouraya} alt="" />
          </div>
          <div className="content">
            <div className="details">
              <h2>Shhouraya Chadha <br /><span>web developer</span></h2>
              <ul className="social_media">
              <li><a href="#"><FaInstagram className="i" /></a></li>
                <li><a href="#"><FaLinkedinIn className="i" /></a></li>
                <li><a href="#"><FaFacebookF className="i" /></a></li>
                {/* <li><a href="#"><FaGithub className="i" /></a></li> */}
              </ul>
            </div>
          </div>
        </div>

    

      </div>
      </div>
    </>
  )
}

export default Newteam